<template>
    <div class="card">
        <div class="card-header h4 m-0 text-center">
            <span v-if="showUserSettings">
                {{ $t('kendoGrid.userSettings') }}
            </span>
            <span v-else>
                {{ $t('kendoGrid.columnsVisibility') }}
            </span>
            <span v-if="userSettings.loadedUserSettings"
                class="badge badge-success">{{ $t('kendoGrid.loadedFromDbUserSettings') }}
            </span>
        </div>
        <div class="card-body row" v-if="showUserSettings">
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.columnMenu')}}
                </label>
                <toggled-btn v-model="userSettings.columnMenu"
                             :sync="true"
                             :name="'columnMenu'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.reorderable')}}
                </label>
                <toggled-btn v-model="userSettings.reorderable"
                             :sync="true"
                             :name="'reorderable'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.resizable')}}
                </label>
                <toggled-btn v-model="userSettings.resizable"
                             :sync="true"
                             :name="'resizable'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.groupable')}}
                </label>
                <toggled-btn v-model="userSettings.groupable"
                             :sync="true"
                             :name="'groupable'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.filterable')}}
                </label>
                <toggled-btn v-model="userSettings.filterable"
                             :sync="true"
                             :name="'filterable'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.sortable')}}
                </label>
                <toggled-btn v-model="userSettings.sortable"
                             :sync="true"
                             :name="'sortable'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.scrollable')}}
                </label>
                <toggled-btn v-model="userSettings.scrollable"
                             :sync="true"
                             :name="'scrollable'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.navigatable')}}
                </label>
                <div class="row align-content-center pl-3">
                    <toggled-btn v-model="userSettings.navigatable"
                                 :sync="true"
                                 :name="'navigatable'"
                                 @input="userSettingsChange">
                    </toggled-btn>
                    <i class="fa fa-info-circle ml-2 mt-1" aria-hidden="true" @click="showModal" style="color:dodgerblue"></i>
                </div>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.rowsPerPage')}}
                </label>
                <vs-select v-if="userSettings.pageable"
                           v-model="userSettings.pageable.size"
                           width="100%"
                           autocomplete
                           @change="userSettingsChange"
                           :placeholder="$t('choose')">
                    <vs-select-item :key="index"
                                    :value="item.value"
                                    :text="item.text"
                                    v-for="(item,index) in pagerSizeDataSource" />
                </vs-select>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.selectable')}}
                </label>
                <vs-select v-model="userSettings.selectable"
                           width="100%"
                           autocomplete
                           @change="userSettingsChange"
                           :placeholder="$t('choose')">
                    <vs-select-item :key="index"
                                    :value="item.value"
                                    :text="item.text"
                                    v-for="(item,index) in selectableDataSource" />
                </vs-select>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.showColumnValueFullText')}}
                </label>
                <toggled-btn v-model="userSettings.showColumnValueFullText"
                             :sync="true"
                             :name="'showColumnValueFullText'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
        </div>

        <div class="card-body row" v-if="showUserSettings && showExcelSettings">
            <div class="col-md-12">
                <h5>{{$t('kendoGrid.excelExportSettings')}}</h5>
                <hr/>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.fileName')}}
                </label>
                <input :type="'text'"
                       :name="'excelFileName_input'"
                       @input="userSettingsChange"
                       v-model="userSettings.excel.fileName"
                       class="form-control"/>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.allPages')}}
                </label>
                <toggled-btn v-model="userSettings.excel.allPages"
                             :sync="true"
                             :name="'excelAllPages_input'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.filterable')}}
                </label>
                <toggled-btn v-model="userSettings.excel.filterable"
                             :sync="true"
                             :name="'excelFilterable_input'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.collapsible')}}
                </label>
                <toggled-btn v-model="userSettings.excel.collapsible"
                             :sync="true"
                             :name="'excelCollapsible_input'"
                             @change="userSettingsChange">
                </toggled-btn>
            </div>
        </div>

        <div class="card-body row" v-if="showUserSettings && showPdfSettings">
            <div class="col-md-12">
                <h5>{{$t('kendoGrid.pdfExportSettings')}}</h5>
                <hr/>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.fileName')}}
                </label>
                <input :type="'text'"
                       :name="'pdfFileName_input'"
                       @input="userSettingsChange"
                       v-model="userSettings.pdf.fileName"
                       class="form-control"/>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.allPages')}}
                </label>
                <toggled-btn v-model="userSettings.pdf.allPages"
                             :sync="true"
                             :name="'pdfAllPages_input'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.avoidLinks')}}
                </label>
                <toggled-btn v-model="userSettings.pdf.avoidLinks"
                             :sync="true"
                             :name="'pdfAvoidLinks_input'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.landscape')}}
                </label>
                <toggled-btn v-model="userSettings.pdf.landscape"
                             :sync="true"
                             :name="'pdfLandscape_input'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.repeatHeaders')}}
                </label>
                <toggled-btn v-model="userSettings.pdf.repeatHeaders"
                             :sync="true"
                             :name="'pdfRepeatHeaders_input'"
                             @input="userSettingsChange">
                </toggled-btn>
            </div>
            <div class="form-group col-lg-3">
                <label class="font-weight-bold">
                    {{$t('kendoGrid.options.scale')}}
                </label>
                <input :type="'number'"
                       :min="0"
                       :max="10"
                       :step="0.1"
                       :name="'pdfScale_input'"
                       @input="userSettingsChange"
                       v-model="userSettings.pdf.scale"
                       class="form-control"/>
            </div>
        </div>

        <div class="card-body row" v-if="showUserSettings">
            <div class="form-group col-md-12">
                <button class="btn btn-primary" @click.stop="saveGridSettings">
                    <i class="far fa-save"></i>
                    {{ $t('buttons.save.btnText') }}
                </button>
                <button class="btn btn-primary" @click.stop="loadGridSettings">
                    <i class="fas fa-cloud-upload-alt"></i>
                    {{ $t('buttons.load.btnText') }}
                </button>
                <button class="btn btn-danger" @click.stop="deleteGridSettings">
                    <i class="far fa-trash-alt"></i>
                    {{ $t('buttons.delete.btnText') }}
                </button>
            </div>
        </div>

        <div class="card-body row" v-if="!showUserSettings">
            <div class="form-group form-check col-md-4"
                v-for="(field, index) in schemaModelFields"
                :key="index">
                <div class="form-group col-lg-6" v-if="field.showHideColumn != false">
                    <label v-if="useLabelAsTitle" class="font-weight-bold">
                        <span v-if="isEnVersion">{{field.labelEn}}</span>
                        <span v-else>{{ field.label }}</span>
                    </label>
                    <label v-else class="font-weight-bold">{{ $t(field.titleKey) }}</label>
                    <toggled-btn v-model="field.visible"
                                 :sync="true"
                                 :name="field.name"
                                 @input="change">
                    </toggled-btn>
                </div>
            </div>
        </div>
        <info-modal ref="infoModal" :show="showForm" @onClose="modalClose"></info-modal>
    </div>
</template>

<script>
    import ToggledBtn from "@/components/toggle/Toggle";
    import InfoModal from "@/components/grid/info.modal"

    export default {
        name: 'grid-user-settings',
        components: {
            'toggled-btn': ToggledBtn,
            'info-modal': InfoModal
        },
        props: {
            schemaModelFields: {},
            componentName: String,
            useLabelAsTitle: { // За динамичните регистри нямаме локализация в bg.js и en.js, а ползваме label и labelEn свойствата на полетата.
                default: false,
                type: Boolean
            },
            showUserSettings: { // Показва потребителски настройки за даден грид, а не само видимост на колоните.
                default: false,
                type: Boolean
            },
            gridOptions: {}
        },
        data() {
            return {
                userSettings: {},
                showForm: false
            };
        },
        mounted() {
            this.getModel();
            this.userSettings = this.gridOptions;
        },
        methods: {
            showModal() {
                this.showForm = true;
            },
            modalClose() {
                this.showForm = false;
            },
            change(value, name) {
                this.$emit('change', this.componentName, name, value);
                if (!this.showUserSettings) {
                    this.saveColumnsVisibility();
                }
            },
            saveGridSettings() {
                if (!this.showUserSettings) {
                    this.saveColumnsVisibility();
                }

                this.$emit('saveGridSettings');
            },
            loadGridSettings() {
                this.$emit('loadGridSettings');
            },
            deleteGridSettings() {
                this.$emit('deleteGridSettings');
            },
            setGridSettings(gridSettings) {
                // От парента се подават настройките на грида след успешен запис.
                // В противен случай се записват винаги подадените при инициализацията на компонента
                this.userSettings = gridSettings;
            },
            saveColumnsVisibility() {
                this.$http.post('/api/personalization/setColumnVisibility', {
                    componentName: this.componentName,
                    settings: this.getModel()
                }).then((response) => {
                    this.$vs.notify({
                        title: response.request ? this.$t('request.response.status.' + response.request.status) : this.$t('request.response.status.200'),
                        text: response.data.message ? response.data.message : (response.request.statusText ? response.request.statusText : response.message),
                        color: 'success',
                        time: this.$store.getters.notificationDuration,
                    })
                }).catch(error => {
                    this.$vs.notify({
                        title: error.response ? this.$t('request.response.status.' + error.response.status) : this.$t('request.response.status.400'),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })
                })
            },
            getModel() {
                var arr = [];
                for (const key in this.schemaModelFields) {
                    if (this.schemaModelFields.hasOwnProperty(key)) {
                        let val = this.schemaModelFields[key];
                        arr.push({ name: val.name, visible: val.visible })
                    }
                }
                return arr;
            },
            userSettingsChange(e) {
                if (this.userSettings.hasOwnProperty('pdf')
                    && this.userSettings.pdf.hasOwnProperty('scale')) {
                    this.userSettings.pdf.scale = Number(this.userSettings.pdf.scale)
                }
                this.$emit('userSettingsChanged', this.userSettings,
                    this.userSettings.pageable.pageSizes.includes(e));
            }
        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            pagerSizeDataSource() {
                var arr = [];
                if (this.userSettings.hasOwnProperty('pageable')
                    && this.userSettings.pageable.hasOwnProperty('pageSizes')) {
                    for (var i = 0; i < this.userSettings.pageable.pageSizes.length; i++) {
                        arr.push({
                            text: this.userSettings.pageable.pageSizes[i],
                            value: this.userSettings.pageable.pageSizes[i]
                        });
                    }
                }

                return arr;
            },
            selectableDataSource() {
                var arr = [
                    {
                        text: 'По подразбиране',
                        value: ''
                    },
                    {
                        text: 'multiple',
                        value: 'multiple'
                    },
                    {
                        text: 'multiple row',
                        value: 'multiple row'
                    },
                    {
                        text: 'multiple cell',
                        value: 'multiple cell'
                    }
                ];
                return arr;
            },
            showExcelSettings() {
                if (!this.userSettings || !this.userSettings.hasOwnProperty('excel')) {
                    return false;
                }

                if (!this.userSettings['excel'].hasOwnProperty('fileName')) {
                    return false;
                }

                return this.userSettings.excel.fileName !== 'Export.xlsx';
            },
            showPdfSettings() {
                if (!this.userSettings || !this.userSettings.hasOwnProperty('pdf')) {
                    return false;
                }

                if (!this.userSettings['pdf'].hasOwnProperty('fileName')) {
                    return false;
                }

                return this.userSettings.pdf.fileName !== 'Export.pdf';
            }
        },
    };
</script>

<style>
    .form-group {
        margin-bottom: 15px;
    }
</style>
